import React, { Component } from "react";
// import { nameToHexColor } from 'name-'
import { Link } from "react-router-dom";

import texture from "../../assets/img/textures/3.png";

function Breadcrumb(props) {
//   const color = nameToHexColor(props.color);
  return (
    <div className="sigma_subheader primary-bg">
      {/* <img src={texture} className="texture-3" alt="" /> */}
      {/* Top Left Wave */}
      <div className="sigma_subheader-shape circles">
        <div className="circle circle-lg circle-1 primary-dark-bg" />
        <div className="circle circle-sm circle-2 bg-white" />
        <div className="circle circle-md circle-3 secondary-bg" />
      </div>
      {/* Bottom Wave */}
      <div className="sigma_subheader-shape waves">
        <div className="wave" />
        <div className="wave" />
      </div>
      <div className="container">
        <div className="sigma_subheader-inner">
          <h1>{props.breadcrumb.pagename}</h1>
        </div>
      </div>
    </div>
  );
}

export default Breadcrumb;
